import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'eq-modal',
	templateUrl: './modal.component.html',
	styleUrls: ['./modal.component.scss']
})

/**
 * This modal is implemented using ng-bootstrap's NgbModal.
 * To add a modal on a page, you must create a <eq-modal> tag with its content as children.
 * 
 * For example:
 * <eq-modal #modalOne [ariaDescribedBy]="'modal-title'">
		<h1 id="modal-title">Modal title</h1>
		<p>Modal text</p>
		<button class="btn btn-primary" (click)="close()">Close</button>
	</eq-modal>
 *
 * Then create a ViewChild on your parent component:
 * @ViewChild('modalOne') private modalOne: ModalComponent;
 * 
 * You can toggle the modal using modalOne.open() and modalOne.close().
 * You can create several modals using several ViewChild elements on your component.
 * For accessibility, you can pass the modal's title ID as the ariaDescribedBy input.
 */
export class ModalComponent {
	@Input() ariaDescribedBy: string;
	@Input() hideCloseBtn = false;
	@Input() isMobileDevice = false;
	@Input() isHamburgerMenu = false;


	@ViewChild('modal') private modalContent: TemplateRef<ModalComponent>;

	private modalRef: NgbModalRef;

	constructor(public modal: NgbModal) {}

	public open(): void {
		this.modalRef = this.modal.open(this.modalContent, {
			centered: true,
			keyboard: true,
			backdrop: 'static',
			ariaDescribedBy: this.ariaDescribedBy
		});
		this.modalRef.result.then();
	}

	public close(): void {
		this.modalRef.close();
	}
}
